import { powerSyncCollectionOptions } from "@tanstack/powersync-db-collection";
import { createCollection } from "@tanstack/react-db";
import type { Role } from "@vidimo/shared";
import { z } from "zod";
import { AppSchema } from "@/lib/powersync-schema.generated";
import { collectionBase } from "./_factory";
import { nullishToNull } from "./nullish";
import { syncedRow } from "./synced-row";

const StaffBaseSchema = syncedRow({
  createdAt: z.string(),
  displayLanguage: z.string().nullable(),
  email: z.string(),
  emailVerified: z.number().nullable(),
  id: z.string(),
  image: z.string().nullable(),
  name: z.string(),
  phone: z.string().nullable(),
  translationLanguage: z.string().nullable(),
  updatedAt: z.string(),
});

// SQLite holds emailVerified as 0/1.
export const SelectStaffSchema = StaffBaseSchema.transform((row) => ({
  ...nullishToNull(row),
  emailVerified: row.emailVerified === 1,
}));

export type Staff = z.infer<typeof SelectStaffSchema>;

// Staff with membership info (role, joinedAt) for UI components.
// `role` is the typed taxonomy from @vidimo/shared — see
// `lib/collections/membership.ts` for the validation source.
// `joinedAt` is the membership's createdAt: an ISO-8601 string, like every
// other date column on the client.
export type StaffWithMembership = Staff & {
  role: Role;
  joinedAt: string;
};

export const staffCollection = createCollection(
  powerSyncCollectionOptions({
    ...collectionBase("staff"),
    schema: SelectStaffSchema,
    table: AppSchema.props.staff,
  })
);
